import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Form, Button, Breadcrumb } from '@themesberg/react-bootstrap';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

import { ApplicationTable } from "../components/ApplicationTable";
import { Link } from 'react-router-dom';
import { Routes } from "../routes";

export default () => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Fetch the logged-in user details from localStorage
    const auth = localStorage.getItem('authToken');
    if (auth) {
      setUser(JSON.parse(auth));
    }
  }, []); // Runs only once on component mount

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><Link to={"/dashboard/overview"}><FontAwesomeIcon icon={faHome} /></Link></Breadcrumb.Item>
            <Breadcrumb.Item active>All Applications</Breadcrumb.Item>
          </Breadcrumb>
          <h4>All Applications</h4>
        </div>

        <div className="btn-toolbar mb-2 mb-md-0">
          {/* Show 'Add New' button only if the logged-in user is an admin (user_type === 1) */}
          {(user?.user_type == 1 || user?.user_type == 2) && (
            <Button as={Link} to={Routes.Addapplication.path} variant="primary" size="sm" className="me-2">
              <FontAwesomeIcon icon={faPlus} className="me-1" /> Add New
            </Button>
          )}
        </div>
      </div>

      <ApplicationTable />
    </>
  );
};
